/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_I18n_Desc2Inputs */

const en_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serves customers in their language, including Arabic and RTL layouts.`)
};

const ar_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يخدم العملاء بلغتهم، بما فيها العربية وتخطيطات RTL.`)
};

const bn_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাস্টমারদের নিজের ভাষায় সেবা দেয়, আরবি আর RTL লেআউটসহ।`)
};

const de_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedient Kunden in ihrer Sprache, einschließlich Arabisch und RTL-Layouts.`)
};

const es_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atiende a los clientes en su idioma, incluido el árabe y diseños RTL.`)
};

const fr_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servez les clients dans leur langue, y compris l'arabe et les mises en page RTL.`)
};

const pt_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atenda clientes no seu idioma, incluindo árabe e layouts RTL.`)
};

const zh_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用客户自己的语言服务，包括阿拉伯语和 RTL 版式。`)
};

const tr_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşterilere kendi dilinde hizmet verir, Arapça ve RTL düzenler dahil.`)
};

const ru_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обслуживает клиентов на их языке, включая арабский и RTL-раскладки.`)
};

const pl_svc_messaging_bots_i18n_desc2 = /** @type {(inputs: Svc_Messaging_Bots_I18n_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługuje klientów w ich języku, łącznie z arabskim i układami RTL.`)
};

/**
* | output |
* | --- |
* | "Serves customers in their language, including Arabic and RTL layouts." |
*
* @param {Svc_Messaging_Bots_I18n_Desc2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_i18n_desc2 = /** @type {((inputs?: Svc_Messaging_Bots_I18n_Desc2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_I18n_Desc2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "de") return de_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "es") return es_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_i18n_desc2(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_i18n_desc2(inputs)
	return en_svc_messaging_bots_i18n_desc2(inputs)
});
export { svc_messaging_bots_i18n_desc2 as "svc_messaging-bots_I18N_desc" }